import { Plus, Check } from "lucide-react";
import { useEnquiry } from "@/context/EnquiryContext";

export const slugify = (s = "") =>
  s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const AddToEnquiryButton = ({ id, name, price, compact = false, className = "" }) => {
  const { hasService, toggleService } = useEnquiry();
  const added = hasService(name, price);
  return (
    <button
      type="button"
      data-testid={`add-enquiry-${id}`}
      onClick={() => toggleService(name, price)}
      className={`inline-flex items-center gap-1.5 rounded-full border font-semibold transition-all duration-200 ${
        compact ? "px-3 py-1 text-[11px]" : "px-3.5 py-1.5 text-xs"
      } ${
        added
          ? "border-[var(--blue)] bg-[var(--blue)]/15 text-[var(--blue-bright)]"
          : "border-[var(--line)] text-white/80 hover:border-[var(--blue)]/60 hover:text-white"
      } ${className}`}
    >
      {added ? <Check size={13} /> : <Plus size={13} />}
      {added ? "Added" : compact ? "Add" : "Add to Enquiry"}
    </button>
  );
};
